export const SET_ACTIVE_FILTERS = 'GalleryPB/*/SetActiveFilters';
